// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IM3V","content":"styles_content__Gl0VK","tableWrap":"styles_tableWrap__2JEHo"};